function cadastroEmail() {
    return "Cadastro Iniciado!";
}

export default cadastroEmail;